import { render, staticRenderFns } from "./AccountDetailComp.vue?vue&type=template&id=a12e4db8&scoped=true"
import script from "./AccountDetailComp.vue?vue&type=script&lang=js"
export * from "./AccountDetailComp.vue?vue&type=script&lang=js"
import style0 from "./AccountDetailComp.vue?vue&type=style&index=0&id=a12e4db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12e4db8",
  null
  
)

export default component.exports